


















import {PortfolioProject} from "@/components/portfolio/PortfolioProject";
import DeviceCollectionView from "@/components/portfolio/DeviceCollection.vue";
import stringsKeys from "@/i18n/strings.json"

export default {
  name: "PortfolioGridItem",
  props: {
    project: {
      type: Object as () => PortfolioProject,
      required: true
    },
  },
  components: {
    DeviceCollectionView
  },
  data: () => {
    return {
      text: stringsKeys,
    }
  },
}
